export const limitProfileNameCellRules = {
	'grid-limit-profile-name ': params => {
		if (params.data) {
			return params.data.Name;
		}
	},
};
